export enum EmailTemplateType {
  DistrictAdminRoleAdded = 'DistrictAdminRoleAdded',
  EmailChanged = 'EmailChanged',
  ForgotPassword = 'ForgotPassword',
  NewDistrictAdmin = 'NewDistrictAdmin',
  NewLicensesAvailableToEducationalUnit = 'NewLicensesAvailableToEducationalUnit',
  NewSchoolAdmin = 'NewSchoolAdmin',
  NewTeacher = 'NewTeacher',
  SchoolAdminRoleAdded = 'SchoolAdminRoleAdded',
  PlatformUpgradePasswordReset = 'PlatformUpgradePasswordReset',
  NewParent = 'NewParent',
  ResendNewLicensesAvailableToEducationalUnit = 'ResendNewLicensesAvailableToEducationalUnit',
  SendPrivacyPolicyUpdatesToAdmin = 'SendPrivacyPolicyUpdatesToAdmin',
}

export enum EmailTemplateTypeName {
  DistrictAdminRoleAdded = 'new role - district admin',
  EmailChanged = 'changed email address',
  ForgotPassword = 'password reset',
  NewDistrictAdmin = 'account activation - district admin',
  NewLicensesAvailableToEducationalUnit = 'licenses available',
  NewSchoolAdmin = 'account activation - school admin',
  NewTeacher = 'account activation - teacher',
  SchoolAdminRoleAdded = 'new role - school admin',
  PlatformUpgradePasswordReset = 'platform upgrade - password reset',
  NewParent = 'account activation - parent',
  ResendNewLicensesAvailableToEducationalUnit = 'resend licenses available',
  SendPrivacyPolicyUpdatesToAdmin = 'send privacy policy updates to admin',
}
